import axios from "axios";
export default axios.create({
    //baseURL:"https://testback-seven.vercel.app/api",
    baseURL:"https://testback-seven.vercel.app/api",
    //baseURL:"https://ahle-tahqiq-backend.onrender.com/api",
    // baseURL:"http://localhost:4000/api",

});
